// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { GatewayClaimGroupViewSearchModel } from './gatewayClaimGroupViewSearchModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class ClaimV1ClaimClaimV1ClaimGroupViewSearchGroupViewSearchRequest {
    'start'?: number;
    'pageSize'?: number;
    'searchModel': GatewayClaimGroupViewSearchModel | null;
    'ignoreClaimsOutsideEnrollmentPeriod'?: boolean;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof ClaimV1ClaimClaimV1ClaimGroupViewSearchGroupViewSearchRequest>> = [
        {
            "name":     "start",
            "baseName": "start",
            "type":     "number"
        },
        {
            "name":     "pageSize",
            "baseName": "pageSize",
            "type":     "number"
        },
        {
            "name":     "searchModel",
            "baseName": "searchModel",
            "type":     "GatewayClaimGroupViewSearchModel"
        },
        {
            "name":     "ignoreClaimsOutsideEnrollmentPeriod",
            "baseName": "ignoreClaimsOutsideEnrollmentPeriod",
            "type":     "boolean"
        },
    ];

    static getAttributeTypeMap() {
        return ClaimV1ClaimClaimV1ClaimGroupViewSearchGroupViewSearchRequest.attributeTypeMap;
    }
}
